import 'css-chunksrc/client/scenes/resourceGroupEdition/groupEditionForm/resourcesList/resource/user/styles.scss';export default {
  "resource": "_resource_13vm8_1",
  "user": "_user_13vm8_8",
  "avatar": "_avatar_13vm8_21",
  "name": "_name_13vm8_33",
  "title": "_title_13vm8_42"
};